<div 
    *ngIf="!data?.length || requesting" 
    class="muted padding-vertical italic" 
    fxLayout="row" 
    fxLayoutAlign="center center">
    <ng-container *ngIf="requesting; else requested">
        {{ 'Loading...' | translate }}
    </ng-container>
    <ng-template #requested>
        {{ 'Empty' | translate }}
    </ng-template>
</div>
